import { useAppMutation } from './useAppMutation';

export interface SetEnrolmentDatesPayload {
  courseEnrollmentId: string;
  /** Bare calendar date, yyyy-MM-dd. Omitted = leave unchanged (clearing is not supported). */
  dueDate?: string;
  /** Bare calendar date, yyyy-MM-dd. Omitted = leave unchanged (clearing is not supported). */
  expiryDate?: string;
}

/** Writes an enrolment's due date and/or course-access expiry through to LearnUpon. */
export const useSetEnrolmentDates = () =>
  useAppMutation<unknown, Error, SetEnrolmentDatesPayload>(
    'put',
    '/TrainingManager/courses/enrollments/dates',
    // Errors surface inline in SetEnrolmentDateDialog; without this the axios interceptor also
    // pops the global error snackbar, showing two messages for one failed save.
    { config: { showSnackbar: false } }
  );
